module.exports = __webpack_public_path__ + "img/speed.1cf16760.png";